import { clampMafiaCount, sanitizePlayerName, MAX_PLAYERS, type MafiaCount } from '@bm/shared';

export interface LocalRoundSetup {
  names: string[];
  mafiaCount: MafiaCount;
}

const STORAGE_KEY = 'bm.localRound';

export const EMPTY_LOCAL_SETUP: LocalRoundSetup = { names: [], mafiaCount: 1 };

/**
 * Merkt sich die letzte Runde des Ein-Gerät-Modus.
 *
 * Gespeichert wird ausschließlich das Setup — die verteilten Rollen bleiben im
 * Arbeitsspeicher. Im `localStorage` wären sie für jeden lesbar, der das Handy
 * ohnehin schon in der Hand hat.
 */
export function loadLocalSetup(): LocalRoundSetup {
  if (typeof localStorage === 'undefined') return EMPTY_LOCAL_SETUP;
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return EMPTY_LOCAL_SETUP;

    const parsed: unknown = JSON.parse(raw);
    if (typeof parsed !== 'object' || parsed === null) return EMPTY_LOCAL_SETUP;

    const { names, mafiaCount } = parsed as { names?: unknown; mafiaCount?: unknown };
    if (!Array.isArray(names)) return EMPTY_LOCAL_SETUP;

    const clean = names
      .filter((name): name is string => typeof name === 'string')
      .map(sanitizePlayerName)
      .filter((name) => name.length > 0)
      .slice(0, MAX_PLAYERS);

    return {
      names: clean,
      mafiaCount: clampMafiaCount(clean.length, typeof mafiaCount === 'number' ? mafiaCount : 1),
    };
  } catch {
    // Kaputter oder gesperrter Storage (Privatmodus) ist kein Fehlerfall.
    return EMPTY_LOCAL_SETUP;
  }
}

export function saveLocalSetup(setup: LocalRoundSetup): void {
  if (typeof localStorage === 'undefined') return;
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(setup));
  } catch {
    // Ohne Storage funktioniert der Modus weiter, nur ohne Gedächtnis.
  }
}
